import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireSrc } from "/data/data/com.termux/files/home/Clientnudb/src/index.js";
var srcExports = requireSrc();
export { srcExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(srcExports);